'use strict';
var type={
	0:'自定义',
	1:'团体票',
	2:'残疾票',
	3:'教师票',
	4:'女士票',
	5:'男士票',
	6:'军人票',
	7:'活动票',
	8:'学生票',
	9:'老人票',
	10:'儿童票',
	12:'成人票',
	13:'双人票',
	14:'情侣票',
	15:'家庭票',
	16:'亲子票',
	17:'自定义'
}

module.exports = {
	ticketType:type
} 






// WEBPACK FOOTER //
// ./src/components/ticket/ticketType.js